import * as React from "react";
import { ReactComponent as LoaderIcon } from "icons/loader.svg";
import styles from "./Loader.module.scss";

export const Loader: React.FC = function () {
  return (
    <div className={styles.loader}>
      <LoaderIcon className={styles.image} />
    </div>
  );
};
